import { platformFeatures } from './data';

export default function FeaturesContent() {
    return (
        <div>
            <h2 className="text-2xl font-bold leading-[1.3] tracking-[-0.5px] text-foreground sm:text-[28px] lg:text-[36px]">
                Features
            </h2>
            <p className="mt-3 text-xs leading-relaxed text-text-light sm:text-sm">
                A super legal app built to simplify justice, business, and everyday legal life. Podus brings together all your legal needs in one connected ecosystem.
            </p>

            <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
                {platformFeatures.map((feature, i) => (
                    <div
                        key={i}
                        className="rounded-2xl border border-border bg-white p-5 sm:p-6"
                    >
                        <h3 className="text-base font-bold text-foreground sm:text-lg">
                            {feature.title}
                        </h3>
                        <p className="mt-2 text-sm leading-relaxed text-text-light">
                            {feature.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
